// request

import axios from 'axios';
import Qs from 'qs';
import { Message } from 'element-ui';
axios.defaults.withCredentials = true;
// 创建axios实例

const ERRORCODE = 1;
const MESSAGEDURATION = 5 * 1000;

const service = axios.create({
    headers: { "X-Requested-With": "XMLHttpRequest" },
    baseURL: process.env.VUE_APP_DOMAIN + "/ApiGateWay", // api的base_url
    transformRequest: [function (data) {
        data = Qs.stringify(data);
        return data;
    }]
});

// request拦截器
service.interceptors.request.use(config => {
    return config;
}, error => {
    // eslint-disable-next-line no-console
    console.log('BEFORE_REQUEST_SEND_ERROR', error); // for debug
    Promise.reject(error);
});

// respone拦截器
service.interceptors.response.use(response => {
    const res = response.data;
    if (res.error === ERRORCODE) {
        if (res.subcode === "need.login") {
            let back = "?back=" + window.encodeURIComponent(window.location.href);
            window.location.href = "https://" + res.link.split("?back=")[0] + back;
            return;
        }
        return Promise.reject(res);
    }
    return res;
},
error => {
    Message({ message: error.message, type: 'error', duration: MESSAGEDURATION });
    return Promise.reject(error);
});

const FetchGet = (url, params) => {
    const options = {
        url,
        method: 'get'
    };
    if (params) {
        options.params = params;
    }
    return service(options);
};

const FetchPost = (url, data, params) => {
    const options = {
        url,
        method: 'post'
    };
    if (data) {
        options.data = data;
    }
    if (params) {
        options.params = params;
    }
    return service(options);
};

export { FetchGet, FetchPost };
